var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('c-card',[_c('template',{slot:"title"},[_vm._v(" "+_vm._s(_vm.name)+" "),(_vm.rating)?_c('el-rate',{staticClass:"rating",attrs:{"value":_vm.rating,"disabled":"","show-score":""}}):_vm._e()],1),_c('div',{attrs:{"slot":"header"},slot:"header"},[(_vm.$is([_vm.$config.groups.COACHEE]))?_c('c-button-link',{attrs:{"to":{
        name: 'coach-invitation',
        params: { id: _vm.id }
      },"round":"","type":"primary"}},[_vm._v(" Zum Coaching einladen ")]):_vm._e(),_c('c-button-link',{attrs:{"to":{
        name: 'coach-detail',
        params: { id: _vm.id }
      },"round":""}},[_vm._v(" Details ")])],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }